export default {"src":"https://cdn-teacher.writinglegends.com/_next/static/media/loading.726a0ece.svg","height":194,"width":150,"blurWidth":0,"blurHeight":0};